import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class ArrisDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default ArrisDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/arris/DeviceSetup.js